export const EXACT_LOCATION_STATUSES = ['CONFIRMED', 'COMPLETED'];
export const APPROX_LOCATION_PRECISION = 'APPROX_2_DECIMAL';

export const canShowExactLocationForStatus = (status) =>
  EXACT_LOCATION_STATUSES.includes(status);

export const roundApproxCoordinate = (value) => {
  const coordinate = Number(value);
  if (!Number.isFinite(coordinate)) {
    return null;
  }
  return Math.round(coordinate * 100) / 100;
};

export const buildApproxLocationFields = ({
  latitude,
  longitude,
  city,
  country,
} = {}) => {
  const approxLatitude = roundApproxCoordinate(latitude);
  const approxLongitude = roundApproxCoordinate(longitude);

  if (approxLatitude == null || approxLongitude == null) {
    return {};
  }

  return {
    approxLatitude,
    approxLongitude,
    locationLabel: [city, country]
      .filter((value) => typeof value === 'string' && value.trim())
      .map((value) => value.trim())
      .join(', '),
    locationPrecision: APPROX_LOCATION_PRECISION,
  };
};

export const getPublicStudioCoordinates = (studio) => {
  const latitude = Number(studio?.approxLatitude ?? studio?.mapLatitude);
  const longitude = Number(studio?.approxLongitude ?? studio?.mapLongitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return null;
  }

  return { latitude, longitude };
};

export const buildCoarseLocationText = (studio) => {
  const safeStudio = studio ?? {};

  if (typeof safeStudio.locationLabel === 'string' && safeStudio.locationLabel.trim()) {
    return safeStudio.locationLabel.trim();
  }

  return [safeStudio.city, safeStudio.country]
    .filter((value) => typeof value === 'string' && value.trim())
    .map((value) => value.trim())
    .join(', ');
};

export const buildExactLocationText = (exactLocation = {}) =>
  [
    exactLocation.streetAndNumber,
    [exactLocation.postcode, exactLocation.city].filter(Boolean).join(' '),
    exactLocation.country,
  ]
    .filter((value) => typeof value === 'string' && value.trim())
    .join(', ');
